import { gql } from 'apollo-boost'

const MENUS_MANUALLY_REMOVED_FROM_MENU_SCRAPING_CLUSTER = gql`
  query menusManuallyRemovedFromScrapingCluster(
    $id: ID!
    $page: Int
    $pageSize: Int
  ) {
    menusManuallyRemovedFromScrapingCluster(
      id: $id
      page: $page
      pageSize: $pageSize
    ) {
      menus {
        id
        url
        brand {
          id
          name
        }
      }
      total
    }
  }
`

export default MENUS_MANUALLY_REMOVED_FROM_MENU_SCRAPING_CLUSTER
